import React from "react";
import {
    AccountBookOutlined,
    AppstoreOutlined,
    AuditOutlined,
    BarChartOutlined,
    BellOutlined,
    BranchesOutlined,
    CalculatorOutlined,
    CalendarOutlined,
    CheckSquareOutlined,
    ClockCircleOutlined,
    CloudUploadOutlined,
    CodeSandboxOutlined,
    ControlOutlined,
    DatabaseOutlined,
    DesktopOutlined,
    DollarOutlined,
    EnvironmentOutlined,
    EyeOutlined,
    FileProtectOutlined,
    FileTextOutlined,
    FolderOutlined,
    FundOutlined,
    GlobalOutlined,
    HistoryOutlined,
    InboxOutlined,
    LayoutOutlined,
    LineChartOutlined,
    MailOutlined,
    MessageOutlined,
    MonitorOutlined,
    NodeIndexOutlined,
    ProfileOutlined,
    RadarChartOutlined,
    ReconciliationOutlined,
    SafetyCertificateOutlined,
    ScanOutlined,
    SearchOutlined,
    SendOutlined,
    SettingOutlined,
    ShopOutlined,
    SwapOutlined,
    TagsOutlined,
    TeamOutlined,
    UploadOutlined,
    UserOutlined,
} from "@ant-design/icons";
import { AirplaneOutlined } from "../../components/icons/SvgIcons";

export const navigationIconComponents = {
    "account-book": AccountBookOutlined,
    "app-store": AppstoreOutlined,
    audit: AuditOutlined,
    bell: BellOutlined,
    branches: BranchesOutlined,
    calculator: CalculatorOutlined,
    calendar: CalendarOutlined,
    "chart-bar": BarChartOutlined,
    "check-square": CheckSquareOutlined,
    "clock-circle": ClockCircleOutlined,
    "cloud-upload": CloudUploadOutlined,
    "code-sandbox": CodeSandboxOutlined,
    control: ControlOutlined,
    database: DatabaseOutlined,
    desktop: DesktopOutlined,
    dollar: DollarOutlined,
    environment: EnvironmentOutlined,
    eye: EyeOutlined,
    "file-protect": FileProtectOutlined,
    "file-text": FileTextOutlined,
    folder: FolderOutlined,
    fund: FundOutlined,
    globe: GlobalOutlined,
    history: HistoryOutlined,
    inbox: InboxOutlined,
    layout: LayoutOutlined,
    "line-chart": LineChartOutlined,
    mail: MailOutlined,
    "market-intelligence": FundOutlined,
    message: MessageOutlined,
    monitor: MonitorOutlined,
    "node-index": NodeIndexOutlined,
    plane: AirplaneOutlined,
    profile: ProfileOutlined,
    "radar-chart": RadarChartOutlined,
    reconciliation: ReconciliationOutlined,
    "safety-certificate": SafetyCertificateOutlined,
    scan: ScanOutlined,
    search: SearchOutlined,
    send: SendOutlined,
    settings: SettingOutlined,
    shop: ShopOutlined,
    swap: SwapOutlined,
    tags: TagsOutlined,
    team: TeamOutlined,
    upload: UploadOutlined,
    user: UserOutlined,
};

export function renderNavigationIcon(iconKey, fallbackIconKey) {
    const Icon = navigationIconComponents[iconKey] || navigationIconComponents[fallbackIconKey] || AppstoreOutlined;
    return React.createElement(Icon);
}
